var map = {
	"./black/duofangguangbo.png": "Gv7b",
	"./blue/duofangguangbo.png": "0odP",
	"./white/duofangguangbo.png": "zX7b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KxdW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duofangguangbo\.png$
// module id = KxdW
// module chunks = 24